import { useCallback } from 'react';

import './index.css';

interface Props {
  label: string;
  value: boolean;
  handleValueChange:
    | React.Dispatch<React.SetStateAction<boolean>>
    | ((value: boolean) => void);
  color?: string;
  isDisabled?: boolean;
}
const Checkbox: React.FC<Props> = (props: Props) => {
  const { label, value, handleValueChange, color, isDisabled } = props;

  const handleOnChange = useCallback(() => {
    handleValueChange(!value);
  }, [handleValueChange, value]);

  return (
    <label className="checkbox-label">
      <input
        className="checkbox.small"
        type="checkbox"
        value={label}
        checked={value}
        onChange={handleOnChange}
        style={{ marginRight: 7, accentColor: color }}
        disabled={isDisabled}
      />
      <span style={{ color }}>{label}</span>
    </label>
  );
};

export default Checkbox;
